// scopes determines what access level or type the user has to that particular customer
// it is based on the customer authorization between a user and a customer
const USER_SCOPES = {
  user: 'user',
  assistant: 'assistant',
}

export const getNextScope = scope =>
  scope === USER_SCOPES.user ? USER_SCOPES.assistant : USER_SCOPES.user

export default USER_SCOPES
